import ArrowDownIcon from "$/lib/icons/ArrowDownIcon";
import CloudUploadIcon from "$/lib/icons/CloudUploadIcon";
import type { FileUploaderContentProps } from "./FileUploader.types";

const FileUploaderContent = ({ dragging }: FileUploaderContentProps) => (
  <div className="pointer-events-none relative flex w-full flex-col items-center gap-6 bg-white">
    <CloudUploadIcon />
    <div className="flex flex-col items-center justify-center gap-4">
      <p className="text-lg font-semibold text-primary-400">
        {dragging ? "Drop it bish" : "Choose a file or drag & drop it here"}
      </p>
      <p className="text-sm font-normal text-tertiary-500">
        JPEG, PNG, PDG, and MP4 formats, up to 50MB
      </p>
      <button
        type="button"
        className="border-ter pointer-events-none rounded-2xl border-2 px-4 py-1 font-semibold text-black outline-none"
      >
        Browse File
      </button>
    </div>
    {dragging && (
      <div className="pointer-events-none absolute left-0 top-0 flex h-full w-full flex-col items-center gap-6 bg-white">
        <ArrowDownIcon className="animate-bounce" />
        <p className="text-xl font-semibold text-primary-400">
          Drop your file here!
        </p>
      </div>
    )}
  </div>
);

export default FileUploaderContent;
